<script setup>
  import GoogleCalendarEmbed from "@/components/GoogleCalendarEmbed.vue";
  import MarkdownRenderer from "@/components/MarkdownRenderer.vue";
</script>

<template>
<section id="join-section">
  <div class="join-wrapper">
    <h2 id="join-team"><a href="#join-team" class="header-link">Join the Team</a></h2>
    <div class="join-info">
      <GoogleCalendarEmbed :calendarId="$store.state.general.calendarId"/>
      <div class="join-text">
        <MarkdownRenderer :content="$store.state.content.join" />
      </div>
    </div>
  </div>
</section>
</template>

<script>
export default {
    name: "JoinView",
    components: {
      GoogleCalendarEmbed,
      MarkdownRenderer,
    },
}
</script>


<style lang="scss">

.join-wrapper{
  position: relative;
  background-color: var(--white);
  padding: var(--section-padding);
  padding-top: 10em;
  padding-bottom: 2rem;
  height: 100%;

  h2{
    margin-top: 0;
    margin-bottom: 1.5rem;
  }
  
  .join-info{
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: center;
    gap: 2em;
    width: 100%;
    max-width: 1100px;
    margin: 0 auto;

    // Left: Calendar
    > *:first-child {
      flex: 2 1 400px;
      min-width: 250px;
      max-width: 700px;
      display: flex;
      justify-content: center;
    }

    // Right: Join text
    .join-text {
      flex: 1 1 250px;
      max-width: 24em;
      text-align: left;
      font-size: 1rem;
      line-height: 1.35;

      a {
        color: var(--medium);
        text-decoration: underline;
        font-weight: bold;
      }
    }
  }
}

// Responsive: stack vertically on small screens
@media screen and (max-width: 900px) {
  .join-wrapper {
    padding: 5.5rem var(--section-padding-mobile, 6%) 1.5rem;

    h2 {
      margin-top: 0;
      margin-bottom: 1rem;
    }

    .join-info {
      flex-direction: column;
      align-items: center;
      gap: 1.25rem;

      > *:first-child,
      .join-text {
        width: 100%;
        max-width: 100%;
        justify-content: center;
      }
      .join-text {
        font-size: 0.95rem;
        line-height: 1.35;
        text-align: left;
        margin-top: 0;
      }
    }
  }
}


</style>